module.exports = __webpack_public_path__ + "img/icon_numberfour.6913444c.svg";